import { fetchSessionHistory } from 'common/components/SessionHistory/services/SessionHistoryApi';
import { ErrorCodes } from 'src/common/responseCodes';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchSimInventoryEntry } from 'simInventory/SimInventoryApi/simInventoryApi';
import { ImsiNotValid } from 'src/rSimInventory/Components/RSimSessionHistory/erros/ImsiNotValid';
import { useSessionHistoryInfiniteQuery } from 'common/components/SessionHistory/hooks/useSessionHistoryInfiniteQuery.ts';

export const useInfinitySessionHistory = (iccid?: string) => {
  const { data: simInventoryEntry, status: simInventoryEntryFetchingStatus } = useSuspenseQuery({
    queryKey: ['SimInventoryEntry', iccid],
    queryFn: () => (iccid ? fetchSimInventoryEntry(iccid) : null),

    retry: (failureCount, error) => {
      if (error instanceof Error && error.message === ErrorCodes.NotFound) {
        return false;
      }
      return failureCount < 3;
    },
  });

  if (simInventoryEntryFetchingStatus === 'success' && !simInventoryEntry?.imsi) {
    throw new ImsiNotValid();
  }

  return useSessionHistoryInfiniteQuery({
    queryKey: ['SessionHistory', simInventoryEntry?.imsi || ''],
    queryFn: async ({ signal, pageParam }) => {
      return fetchSessionHistory(simInventoryEntry!.imsi!, pageParam as Date, false, signal);
    },
    enabled: simInventoryEntryFetchingStatus === 'success' && !!simInventoryEntry?.imsi,
  });
};
